/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { CompteBancaireDto } from './CompteBancaireDto';
import {
    CompteBancaireDtoFromJSON,
    CompteBancaireDtoFromJSONTyped,
    CompteBancaireDtoToJSON,
} from './CompteBancaireDto';

/**
 * 
 * @export
 * @interface ApprenantDoublonSearch
 */
export interface ApprenantDoublonSearch {
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    registreNational?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprenantDoublonSearch
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    nationalite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    codesexe?: string | null;
    /**
     * 
     * @type {CompteBancaireDto}
     * @memberof ApprenantDoublonSearch
     */
    compteBancaire?: CompteBancaireDto;
    /**
     * 
     * @type {boolean}
     * @memberof ApprenantDoublonSearch
     */
    beid?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    beidnumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    remarque?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprenantDoublonSearch
     */
    dateDeces?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    codePaysNaissance?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    localiteNaissance?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    communeNaissance?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantDoublonSearch
     */
    idpersonne?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApprenantDoublonSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ApprenantDoublonSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantDoublonSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ApprenantDoublonSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ApprenantDoublonSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ApprenantDoublonSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ApprenantDoublonSearch interface.
 */
export function instanceOfApprenantDoublonSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApprenantDoublonSearchFromJSON(json: any): ApprenantDoublonSearch {
    return ApprenantDoublonSearchFromJSONTyped(json, false);
}

export function ApprenantDoublonSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprenantDoublonSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'compteBancaire': !exists(json, 'compteBancaire') ? undefined : CompteBancaireDtoFromJSON(json['compteBancaire']),
        'beid': !exists(json, 'beid') ? undefined : json['beid'],
        'beidnumber': !exists(json, 'beidnumber') ? undefined : json['beidnumber'],
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'dateDeces': !exists(json, 'dateDeces') ? undefined : (json['dateDeces'] === null ? null : new Date(json['dateDeces'])),
        'codePaysNaissance': !exists(json, 'codePaysNaissance') ? undefined : json['codePaysNaissance'],
        'localiteNaissance': !exists(json, 'localiteNaissance') ? undefined : json['localiteNaissance'],
        'communeNaissance': !exists(json, 'communeNaissance') ? undefined : json['communeNaissance'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ApprenantDoublonSearchToJSON(value?: ApprenantDoublonSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': value.nom,
        'prenom': value.prenom,
        'registreNational': value.registreNational,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'nationalite': value.nationalite,
        'codesexe': value.codesexe,
        'compteBancaire': CompteBancaireDtoToJSON(value.compteBancaire),
        'beid': value.beid,
        'beidnumber': value.beidnumber,
        'remarque': value.remarque,
        'dateDeces': value.dateDeces === undefined ? undefined : (value.dateDeces === null ? null : value.dateDeces.toISOString()),
        'codePaysNaissance': value.codePaysNaissance,
        'localiteNaissance': value.localiteNaissance,
        'communeNaissance': value.communeNaissance,
        'idpersonne': value.idpersonne,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

